import { Trans, useTranslation } from "react-i18next"
import styled from "styled-components"

const TutorDiv = styled.div`
    padding: 40px;

    gap: 20px;

    @media (max-width: 1100px) {
        flex-direction: column;
    }
`
const Photo = styled.img`
    width: 300px;
    height: 100%;
    border-radius: 1rem;
    margin: 20px;
    @media (max-width: 1100px) {
        max-width: 75%;
    }
`

const Info = styled.div`
    color: lightgray;
    text-align: justify;
    p {
        margin: 20px 0px;
    }
    strong {
        color: white;
    }
`

const InfoTable = styled.table`
margin: 20px;
width: 100%;
    * {
        text-align: start;
    }
border-bottom: 1px gray solid;
border-top: 1px gray solid;

`

const ReferenceAuthor = styled.span`
font-style: normal;
font-weight: bold;

`
const Reference = styled.p`
    font-style: italic;
`
const Intro = styled.div`
    display: flex;
    @media (max-width: 1100px) {
        flex-direction: column;
        align-items: center;
    }
`
const IntroText = styled.div`
`

export default function Tutor() {
    useTranslation();

    return <TutorDiv>
        <Info>
            <Intro>
                <IntroText>
                    <p><Trans i18nKey="programming.hi">Hi,</Trans></p>
                    <p>
                        <Trans i18nKey="programming.teaching"><strong>I teach computer science and programming</strong> in different languages. I've been doing this for about 4 years now, and in that time, I've helped a lot of <strong>university students pass their exams</strong>, assisted <strong>junior programmers in preparing for their interviews</strong>, and shared my programming knowledge with those who were looking for a new hobby.</Trans>
                    </p>
                    <p>
                        <Trans i18nKey="programming.details">I also have teaching experience from <strong>leading seminar groups at Masaryk University</strong> in Brno, where I taught courses dealing with C#, the basics of algorithmization, and 3D modeling. In the past, I worked as a programmer. Today, I am working on a PhD in computer visualization, but I enjoy teaching - especially those who want to gain knowledge voluntarily. I'm teaching <strong>online</strong>, and the times are subject to agreement - I prefer the afternoon or the evening, but I am also available for the night owls :)</Trans>
                    </p>
                </IntroText>
                <Photo src="https://i.imgur.com/MX5rxfr.jpg" />
            </Intro>

            <InfoTable>
                <thead>
                    <tr>
                        <th><Trans i18nKey="programming.price">Price</Trans></th>
                        <th><Trans i18nKey="programming.time">Preffered times</Trans></th>
                        <th><Trans i18nKey="programming.langs">Languages</Trans></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><Trans i18nKey="programming.pricevalue">starting at 20 Euro/hour</Trans></td>
                        <td><Trans i18nKey="programming.timevalue">afternoon, evenings, weekends</Trans></td>
                        <td><Trans i18nKey="programming.langsvalue">Python, Java, C, C#, HTML, Javascript, and other</Trans></td>
                    </tr>
                </tbody>
            </InfoTable>
            <Trans i18nKey="programming.refs">Selected references from tutoring websites (in Slovak):</Trans>
            <Reference>
                <ReferenceAuthor>Peter F.:</ReferenceAuthor> Filip výborne vysvetľuje. Už po niekoľkých hodinách sa chytám v jednoduchších zadaniach v programovacom jazyku c, začal som od úplnych základov. Môžem ho iba odporučiť!
            </Reference>

            <Reference>
                <ReferenceAuthor>Tomas G.:</ReferenceAuthor> Filipa som kontaktoval so zufalou prosbou "naucit sa programovat v pythone", najma pre korespondencny seminar na univerzitu, na ktorom sme sa stale dalej a dalej zahlbovali do pythonu. Plynule sme od seminarnych uloh presli na eticky hacking, kde sme prechadzali jednotlivymi druhmi utokov.. (Je vidiet vysoku uroven vedomosti, ktore dokaze podat "bezbolestne" tak, ze clovek napato caka co bude na dalsej hodine) Hlavnou vyhodou je individualny pristup, ziadne ucebnicove metody... pri probleme sa najskor treba zamysliet, malymi napovedami vsak usmerni k rieseniu. Hodiny mozem len doporucit :)
            </Reference>

            <Reference>
                <ReferenceAuthor>Andrea M.:</ReferenceAuthor> S Filipom som nad mieru spokojná, priebežne ma pripravoval na skúšku z Javy. Naozaj sa uistí že téme chápem, kladie navádzajúce otázky čím núti rozmýšlať - je to náročný učiteľ, vysvetľuje ale skvele :D
            </Reference>

            <Reference>
                <ReferenceAuthor>Linda M.:</ReferenceAuthor> Veľmi ďakujem a určite Filipa odporúčam. Jeho štýl výučby mi vyhovoval pretože ma najprv nechal nad úlohami rozmýšľať a dával mi nápovedy aby som ich skúsila riešiť sama, a vždy keď som nevedela ako tak mi všetko vysvetlil...a po pár hodinách ma to programovanie aj viac baví :)
            </Reference>

        </Info>
    </TutorDiv>

}